var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _g, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 198,
    viewBox: "0 0 246 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.022 94.6842C161.022 75.9882 144.667 60.832 124.492 60.832C104.316 60.832 87.9609 75.9882 87.9609 94.6842",
    stroke: "url(#paint0_radial_1877_14605)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.852 94.6862C172.852 70.2375 151.201 50.418 124.492 50.418C97.7841 50.418 76.1328 70.2375 76.1328 94.6862",
    stroke: "url(#paint1_radial_1877_14605)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.681 94.6843C184.681 64.483 157.89 40 124.841 40C91.7916 40 65 64.483 65 94.6843",
    stroke: "url(#paint2_radial_1877_14605)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.021 103.799C161.021 122.135 144.977 137 125.186 137C105.395 137 89.3516 122.135 89.3516 103.799",
    stroke: "url(#paint3_radial_1877_14605)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.851 103.797C172.851 127.886 151.511 147.414 125.187 147.414C98.8632 147.414 77.5234 127.886 77.5234 103.797",
    stroke: "url(#paint4_radial_1877_14605)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.68 103.799C184.68 133.64 158.2 157.832 125.535 157.832C92.8707 157.832 66.3906 133.64 66.3906 103.799",
    stroke: "url(#paint5_radial_1877_14605)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 197.5L48.1716 114.265C53.3209 105.179 62.9579 99.5637 73.4016 99.5637H170.428C180.686 99.5637 190.18 94.1452 195.397 85.3138L245.5 0.5",
    stroke: "url(#paint6_linear_1877_14605)",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter0_f_1877_14605)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.717,
    cy: 99.5026,
    r: 37.0651,
    fill: "#6016B5",
    fillOpacity: 0.45
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1877_14605)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8606,
    height: 39.893,
    rx: 6,
    transform: "matrix(0.669597 -0.742724 0.743565 0.668664 96.2461 101.328)",
    fill: "#592788"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1877_14605)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8837,
    height: 39.8705,
    rx: 6,
    transform: "matrix(0.945645 -0.325201 0.325936 0.945392 98.9297 87.293)",
    fill: "#9042E8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 94.25H131.047C132.067 94.25 132.577 94.25 132.844 94.5327C133.11 94.8162 133 95.2407 132.778 96.0905L132.447 97.3655C131.946 99.281 130.118 100.706 127.9 101M118.975 94.25H117.953C116.933 94.25 116.422 94.25 116.156 94.5327C115.89 94.8162 116 95.2407 116.222 96.0905L116.553 97.3655C117.054 99.281 118.882 100.706 121.1 101M124.5 103.25C123.077 103.25 121.84 104.199 121.2 105.598C120.894 106.267 121.333 107 121.914 107H127.085C127.667 107 128.105 106.267 127.8 105.598C127.16 104.199 125.923 103.25 124.5 103.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.501 103.25C127.068 103.25 129.231 99.7535 129.882 94.9925C130.061 93.677 130.151 93.0185 129.675 92.5092C129.199 92 128.43 92 126.892 92H122.11C120.572 92 119.803 92 119.327 92.5092C118.851 93.0185 118.942 93.677 119.121 94.9932C119.771 99.7535 121.934 103.25 124.501 103.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14605",
    x: 49.2523,
    y: 24.0375,
    width: 150.929,
    height: 150.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.2,
    result: "effect1_foregroundBlur_1877_14605"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1877_14605",
    x: 98.7227,
    y: 73.4531,
    width: 63.0703,
    height: 57.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360781 0 0 0 0 0.256029 0 0 0 0 0.898828 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1877_14605"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1877_14605",
    x: 100.555,
    y: 75.6211,
    width: 59.4062,
    height: 52.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360781 0 0 0 0 0.256029 0 0 0 0 0.898828 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1877_14605"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.492 77.7581) rotate(90) scale(16.9261 36.5306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.492 72.5521) rotate(90) scale(22.1341 48.3596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.841 67.3422) rotate(90) scale(27.3422 59.8407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.186 120.399) rotate(-90) scale(16.6006 35.8348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.187 125.605) rotate(-90) scale(21.8086 47.6638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1877_14605",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.535 130.815) rotate(-90) scale(27.0167 59.1448)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D043D",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1877_14605",
    x1: -4.13606,
    y1: 222.353,
    x2: 252.452,
    y2: 13.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.440267,
    stopColor: "#C8BDFF",
    stopOpacity: 0.842733
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522427,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83629,
    stopColor: "#D8D0FF",
    stopOpacity: 0.593586
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeProfitIcon);
export default __webpack_public_path__ + "static/media/TakeProfitIcon.a52b19a9c1dfb408d2100e1a0f5e3aa5.svg";
export { ForwardRef as ReactComponent };